import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'
import type { ReturnsReturnProcessIdentification } from '@itsrever/rever-api'
import { returnsApiProxy } from '@/redux/api/returns-api-slice'

export const getTrackingInfoQuery = ({
  email,
  process_id
}: Partial<ReturnsReturnProcessIdentification>) =>
  queryOptions({
    queryKey: ['tracking-info', email, process_id],
    queryFn:
      email !== undefined && process_id !== undefined
        ? async () => {
            const { data } = await returnsApiProxy.trackingInfo({
              returnsTrackingInfoRequest: {
                return_process_identification: { email, process_id }
              }
            })

            return data
          }
        : skipToken,
    staleTime: Infinity
  })

export const useTrackingInfo = (
  identification: Partial<ReturnsReturnProcessIdentification>
) => {
  return useQuery(getTrackingInfoQuery(identification))
}
